export const CLOUD_TOOL_ID = "cloud";

const drawCloud = ({ ctx, from, to, penSize }) => {
  const left = Math.min(from.x, to.x);
  const top = Math.min(from.y, to.y);
  const right = Math.max(from.x, to.x);
  const bottom = Math.max(from.y, to.y);
  const width = right - left;
  const height = bottom - top;

  if (width < 4 || height < 4) {
    return;
  }

  const bump = Math.max(10, penSize * 4);
  const radius = bump / 2;

  ctx.beginPath();

  for (let x = left; x <= right; x += bump) {
    const px = Math.min(x + radius, right);
    ctx.moveTo(px - radius, top);
    ctx.arc(px, top, radius, Math.PI, 0, false);
  }
  for (let y = top; y <= bottom; y += bump) {
    const py = Math.min(y + radius, bottom);
    ctx.moveTo(right, py - radius);
    ctx.arc(right, py, radius, -Math.PI / 2, Math.PI / 2, false);
  }
  for (let x = right; x >= left; x -= bump) {
    const px = Math.max(x - radius, left);
    ctx.moveTo(px + radius, bottom);
    ctx.arc(px, bottom, radius, 0, Math.PI, false);
  }
  for (let y = bottom; y >= top; y -= bump) {
    const py = Math.max(y - radius, top);
    ctx.moveTo(left, py + radius);
    ctx.arc(left, py, radius, Math.PI / 2, -Math.PI / 2, false);
  }

  ctx.stroke();
};

export const cloudToolConfig = {
  id: CLOUD_TOOL_ID,
  usesPreview: true,
  cursor: "crosshair",
  onStart: () => true,
  onMove: ({ ctx, lastPointRef, nextPoint, penSize }) => {
    drawCloud({
      ctx,
      from: lastPointRef.current,
      to: nextPoint,
      penSize,
    });
  },
  onEnd: ({ ctx, lastPointRef, endPoint, penSize }) => {
    drawCloud({
      ctx,
      from: lastPointRef.current,
      to: endPoint,
      penSize,
    });
  },
};

const CloudToolButton = ({ activeTool, onSelectTool }) => {
  return (
    <button
      type="button"
      className={`btn ${
        activeTool === CLOUD_TOOL_ID ? "btn-dark" : "btn-outline-dark"
      }`}
      onClick={() => onSelectTool(CLOUD_TOOL_ID)}
      title="Cloud"
      aria-label="Cloud"
    >
      ☁
    </button>
  );
};

export default CloudToolButton;
